module.exports = __webpack_public_path__ + "img/9791188949212.0aa33fd8.jpg";